import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Tipografia } from "../../../../_common";

TimelineItemEventoCustomDuplicado.propTypes = {
  eventoCustom: PropTypes.object,
};

function TimelineItemEventoCustomDuplicado({ eventoCustom }) {
  const intl = useIntl();

  return (
    <Tipografia>
      {intl.formatMessage(
        {
          defaultMessage: `Lead duplicado de {linkLead}. Movido para: {funilDestino} - {etapaDestino}`,
        },
        {
          linkLead: <a href={`/spotter/detalhes-lead/${eventoCustom.leadId}`}>{eventoCustom.leadNome}</a>,
          funilDestino: eventoCustom.funilDestino,
          etapaDestino: eventoCustom.etapaDestino,
        }
      )}
    </Tipografia>
  );
}

export default TimelineItemEventoCustomDuplicado;
